'use strict';

// Browser entry. Exposes the engine on window.Web3Keys (used by test harnesses) and
// boots the UI when the real app page is present.

const identity = require('./crypto/identity');
const api = require('./api');
const { registerFlow, loginFlow } = require('./engineflows');
const vcjwt = require('./crypto/vcjwt');
const did = require('./crypto/did');

const Web3Keys = Object.assign({}, identity, { api, registerFlow, loginFlow, vcjwt, did });

if (typeof window !== 'undefined') {
  window.Web3Keys = Web3Keys;
  const { bootstrap } = require('./ui/flows');
  if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
}

module.exports = Web3Keys;
